
import { defineComponent, PropType } from 'vue'
import { TodoItem } from '@/types'
export default defineComponent({
	name: 'TodoCard',
	props: {
		todo: {
			type: Object as PropType<TodoItem>
		}
	}
})
